import FavouriteButton from './FavouriteButton';
import FavouriteButtonContainer, { OwnProps } from './FavouriteButton.container';

export { type OwnProps as Props };

export default FavouriteButtonContainer(FavouriteButton);
